<template>
    <C1FormGroup class="af-attributes-group">
        <div class="afu-flex afu-items-center afu-justify-between">
            <C1Label
                class="afu-text-gray-700 afu-flex afu-justify-between"
            >
                <span>{{ attributeLabel }}</span>
            </C1Label>

            <div class="afu-mb-2">
                <div
                    class="af-attributes-group-select-all afu-flex afu-items-center afu-cursor-pointer"
                    @click="onSelectAll()"
                >
                    <FontAwesomeIcon
                        :icon="isAllSelected ? ['far', 'check-square'] : ['fas', 'square']"
                        class="af-attributes-group-select-all-icon afu-mr-2"
                        :class="{
                            'afu-text-gray-400': !isAllSelected,
                            'afu-text-primary-400': isAllSelected,
                        }"
                    />

                    <span class="afu-text-gray-700 afu-text-sm">{{ `Any ${attributeLabel.toLocaleLowerCase()}` }}</span>
                </div>
            </div>
        </div>

        <div class="af-attributes-group-container afu-flex afu-flex-wrap afu-flex-col md:afu-flex-row md:afu-items-center afu-bg-white afu-border afu-border-solid afu-border-gray-200 afu-px-4 afu-pt-4 afu-pb-2 afu-rounded-md">
            <div
                v-for="option in attributeOptions"
                :key="option.value"
                class="af-attributes-group-item afu-inline-flex afu-items-center afu-rounded-lg afu-px-3 afu-py-2 sm:afu-mr-2 afu-mb-2 afu-cursor-pointer afu-transition afu-ease-in-out afu-duration-150"
                :class="{
                    'afu-text-gray-800 afu-bg-gray-200': !option.is_selected,
                    'is-active afu-text-white afu-bg-primary-400': option.is_selected,
                }"
                @click="onSelect(option)"
            >
                <FontAwesomeIcon
                    :icon="option.is_selected ? ['far', 'check-square'] : ['fas', 'square']"
                    class="af-attributes-group-icon"
                    :class="{
                        'afu-text-gray-400': !option.is_selected,
                    }"
                    style="font-size: 16px;"
                />

                <div class="af-attributes-group-label afu-ml-2 afu-text-sm">
                    {{ option.value }}
                </div>
            </div>
        </div>
    </C1FormGroup>
</template>

<script>
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import C1Label from '@/components/C1Components/C1Label';

    export default {
        name: 'SearchAttributesGroup',
        components: { C1Label, C1FormGroup },

        props: {
            attributeCode: {
                type: String,
                required: true,
            },

            attributeLabel: {
                type: String,
                required: true,
            },

            options: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                id: `attribute_group_${this.attributeCode}_${this._uid}`,
                attributeOptions: [],
            };
        },

        computed: {
            isAllSelected() {
                return this.attributeOptions.filter(o => o.is_selected).length === this.attributeOptions.length;
            },
        },

        created() {
            this.cloneAttributeOptions();
        },

        watch: {
            options() {
                this.cloneAttributeOptions();
            },
        },

        methods: {
            cloneAttributeOptions() {
                this.attributeOptions = this.options.map(o => ({
                    ...o,
                    is_selected: false,
                }));
            },

            onSelect(attributeOption) {
                attributeOption.is_selected = !attributeOption.is_selected;

                this.syncAttributes();
            },

            onSelectAll() {
                const shouldSelect = !this.isAllSelected;
                this.attributeOptions.forEach((o) => {
                    o.is_selected = shouldSelect;
                });

                this.syncAttributes();
            },

            syncAttributes() {
                const data = {
                    selected: this.attributeOptions.filter(o => o.is_selected),
                    attribute: this.attributeCode,
                };
                this.$emit('handleSelect', data);
            },
        },
    };
</script>
